import { useScrollReveal } from '@/hooks/useScrollReveal';

const services = [
  {
    icon: 'ri-smartphone-line',
    title: 'Cep Telefonu Tamiri',
    desc: 'Ekran değişimi, batarya yenileme, kamera onarımı, su hasarı ve tüm telefon arızalarında hızlı çözüm.',
    color: 'from-rose-400 to-pink-500',
  },
  {
    icon: 'ri-store-2-line',
    title: 'İkinci El Telefon Satışı',
    desc: 'Test edilmiş, garantili ikinci el akıllı telefonlar. iPhone, Samsung, Xiaomi ve daha fazlası uygun fiyatla.',
    color: 'from-fuchsia-400 to-violet-500',
  },
  {
    icon: 'ri-computer-line',
    title: 'Laptop Tamiri',
    desc: 'Ekran değişimi, klavye tamiri, anakart onarımı ve tüm donanım sorunlarında profesyonel çözüm.',
    color: 'from-orange-400 to-red-500',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Format & Kurulum',
    desc: 'Windows, Linux kurulumu, sürücü yükleme, sistem optimizasyonu ve veri yedekleme hizmetleri.',
    color: 'from-emerald-400 to-teal-500',
  },
  {
    icon: 'ri-camera-line',
    title: 'Kamera Sistemleri',
    desc: 'IP kamera, analog kamera kurulumu, DVR/NVR yapılandırması ve uzaktan izleme sistemleri.',
    color: 'from-sky-400 to-cyan-500',
  },
  {
    icon: 'ri-bank-card-line',
    title: 'POS Cihaz Servisi',
    desc: 'Tüm marka POS cihazlarının tamiri, yazılım güncellemesi ve teknik destek hizmetleri.',
    color: 'from-amber-400 to-orange-500',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Güvenlik Sistemleri',
    desc: 'Alarm sistemleri, erişim kontrol, kartlı geçiş sistemleri kurulum ve bakım hizmetleri.',
    color: 'from-green-400 to-emerald-500',
  },
  {
    icon: 'ri-cpu-line',
    title: 'Donanım Yükseltme',
    desc: 'RAM artırımı, SSD yükseltme, ekran kartı değişimi ile bilgisayarınızı yenileyin.',
    color: 'from-pink-400 to-rose-500',
  },
  {
    icon: 'ri-wifi-line',
    title: 'Ağ & İnternet',
    desc: 'Kablolu/kablosuz ağ kurulumu, router yapılandırması, VPN ve ağ güvenliği çözümleri.',
    color: 'from-teal-400 to-cyan-500',
  },
  {
    icon: 'ri-printer-line',
    title: 'Yazıcı Servisi',
    desc: 'Lazer ve inkjet yazıcı tamiri, kartuş dolumu, sürücü kurulumu ve bakım hizmetleri.',
    color: 'from-lime-400 to-green-500',
  },
];

const ServicesSection = () => {
  const { ref: titleRef, visible: titleVisible } = useScrollReveal(0.1);
  const { ref: gridRef, visible: gridVisible } = useScrollReveal(0.05);

  return (
    <section className="py-20 bg-slate-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div
          ref={titleRef}
          className={`text-center mb-14 transition-all duration-700 ${titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <span className="inline-block bg-orange-100 text-orange-600 text-xs font-semibold px-3 py-1 rounded-full mb-3 uppercase tracking-wider">
            Hizmetlerimiz
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-4">
            Teknik Servis Hizmetlerimiz
          </h2>
          <p className="text-slate-500 text-base max-w-2xl mx-auto">
            Format atmaktan laptop tamirine, kamera sistemlerinden POS cihazlarına kadar geniş teknik servis hizmetleri sunuyoruz.
          </p>
          <div className="w-16 h-1 bg-orange-500 rounded-full mx-auto mt-5"></div>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, i) => (
            <div
              key={i}
              className={`bg-white rounded-xl p-6 hover:-translate-y-2 transition-all duration-500 border border-slate-100 group cursor-pointer ${gridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              style={{ transitionDelay: gridVisible ? `${i * 80}ms` : '0ms' }}
            >
              <div className={`w-14 h-14 flex items-center justify-center rounded-xl bg-gradient-to-br ${service.color} mb-5 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-slate-900 font-bold text-base mb-2">{service.title}</h3>
              <p className="text-slate-500 text-sm leading-relaxed">{service.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
